import { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "../api/authApi";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // { username, roles: [] }
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await authApi.me();

      // backend-in response-u Roles/roles ola bilər, ikisini də tuturuq
      const roles = data.roles || data.Roles || [];
      const username = data.userName || data.UserName || data.username || data.Username;

      setUser({ username, roles });
    } catch {
      localStorage.removeItem("token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const login = async (username, password) => {
    const { data } = await authApi.login(username, password);
    localStorage.setItem("token", data.token || data.Token);
    await loadMe();
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  const hasRole = (...roles) => {
    if (!user?.roles?.length) return false;
    return roles.some((r) => user.roles.includes(r));
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, hasRole }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
